<script lang="ts">
  import { _ } from "svelte-i18n";
  import Button from "$lib/components/Button/Button.svelte";
  export let label = $_("Add to Bag");
  export let disabled = false;

  $: label = label;
</script>

<Button primary fullWidth {disabled} on:click {label} />
